import React, { useEffect, useState } from 'react';
import Tab from '@mui/material/Tab';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'layouts/users/services/userApis';
import { showLoader, useNotification } from 'utils/commonUtils';
import { PCard, StickyTab, TabContainer } from 'components/Ui/styled';
import TabPanel, { a11yProps } from 'components/Common/TabPanel/TabPanel';
import EmployeeDocumentsTab from './employeeDocumentTab/EmployeeDocumentsTab';
import StagedDocumentsTab from './stagedEmployeeDocumentsTab/StagedDocumentsTab';
import GeneralInfoTab from 'layouts/staffProfile/components/staffProfileTabs/GeneralInfoTab';
import { setEmployeeDetails } from 'layouts/documentManagement/store/employeeDetailsSlice/employeeDetailsSlice';
import { getStagedEmployeeDocuments } from 'layouts/documentManagement/services/documentManagementApi';
import { setStagedEmployeeDocuments } from 'layouts/documentManagement/store/stagedEmployeeDocumentsSlice/stagedEmployeeDocumentsSlice';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';

const EmployeeDocumentTabs = () => {
  const dispatch = useDispatch();
  const { handleErrorResponse, NotificationPopup } = useNotification();
  const canManageEmploymentDocuments = usePermissionCustomHook(
    'CAN_MANAGE_EMPLOYMENT_DOCUMENTS'
  );

  const [value, setValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const employee = useSelector((state) => state.employee?.employee);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    fetchEmployee();
  }, []);

  useEffect(() => {
    if (canManageEmploymentDocuments) {
      fetchStagedEmployeeDocuments();
    }
  }, [canManageEmploymentDocuments]);

  const fetchEmployee = async () => {
    try {
      setIsLoading(true);
      const employeeDetails = await getUser(employee);
      dispatch(setEmployeeDetails(employeeDetails?.user));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const fetchStagedEmployeeDocuments = async () => {
    try {
      setIsLoading(true);
      const stagedEmployeeDocuments = await getStagedEmployeeDocuments(
        employee
      );
      dispatch(setStagedEmployeeDocuments(stagedEmployeeDocuments?.documents));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  if (isLoading) {
    return showLoader();
  }

  return (
    <PCard>
      <TabContainer>
        <StickyTab
          primary={!canManageEmploymentDocuments}
          value={value}
          onChange={handleTabChange}
          aria-label="employeeDocumentTabs"
        >
          <Tab label="General Info" {...a11yProps(0)} />
          {canManageEmploymentDocuments && (
            <Tab label="Employee Documents" {...a11yProps(1)} />
          )}
          {canManageEmploymentDocuments && (
            <Tab label="Staged Documents" {...a11yProps(2)} />
          )}
        </StickyTab>
        <TabPanel value={value} index={0}>
          <GeneralInfoTab />
        </TabPanel>
        {canManageEmploymentDocuments && (
          <TabPanel value={value} index={1}>
            <EmployeeDocumentsTab />
          </TabPanel>
        )}
        {canManageEmploymentDocuments && (
          <TabPanel value={value} index={2}>
            <StagedDocumentsTab />
          </TabPanel>
        )}
      </TabContainer>
      <NotificationPopup />
    </PCard>
  );
};

export default EmployeeDocumentTabs;
